export default "__VITE_ASSET__ChGn2oy4__"